import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Spring } from 'react-spring';
import { history } from '../../helpers/history';
import SaayaLogo from '../../static/images/saayalogo.png';
import AlfalahLogo from '../../static/images/alfalahlogo.png';
import PakQatarLogo from '../../static/images/pakqatarlogo.png';
import Footer from '../../components/Footer/footer';
import { constants } from '../../Constants';
import { emailConfirm } from '../../helpers/ConstantID';
import { contactUsEmail } from '../../config';
import defaultImage from '../../static/images/default_BG.png';
class ConfirmationView extends Component {
	constructor(props) {
		super(props);
		this.state = {
			is_mobile: false,
		};
	}

	componentDidMount() {
		window.innerWidth <= 700 ? this.setState({ is_mobile: true }) : this.setState({ is_mobile: false });
	}

	redirectToSignIn() {
		history.replace('/');
	}

	render() {
    const {whitelabel} = this.props;
		return (
			<div className="sh-layout">
				<div className="sh-email-confirm-comp">
					<div className="sh-gnrl-inner">
						<div className="sh-gnrl-logo">
                <img src={whitelabel ? whitelabel[0].logo_url : defaultImage} alt="logo" id={emailConfirm.sh_ec_logo} />
              
							
						</div>
						<div className="sh-ecc-heading">
							<h2 className="sh-ecc-h2 sh-mb-15" id={emailConfirm.sh_ec_text1}>
								{constants.EMAIL_CONFIRMATION}
							</h2>
							<p className="sh-ecc-gnrl-text sh-mb-20" id={emailConfirm.sh_ec_text2}>
								{constants.EMAIL_CONFIRM_MSG.replace('{0}', 'active your account')}
							</p>
						</div>
						<div className="sh-ecc-form">
							<div className="sh-gnrl-row sh-mb-15">
								<button
									id={emailConfirm.sh_ec_btn}
									className="sh-gnrl-btn sh-login-btn"
									onClick={this.redirectToSignIn}
								>
									{constants.SIGN_IN}
								</button>
							</div>

							<div className="sh-gnrl-row">
								<label htmlFor={emailConfirm.sh_ec_cs_btn} className="sh-ecc-cnslr">
									{constants.EMAIL_CONFIRMATION_TXT}
									<a className="mobile-contact-help" href={`mailto:${contactUsEmail}`}>
										{constants.CUSTOMER_SUPPORT_TXT}
									</a>
								</label>
								<button
									className="sh-ecc-cnslr-btn"
									onClick={() => {
										console.log('this is button click');
									}}
									id={emailConfirm.sh_ec_cs_btn}
								></button>
							</div>
						</div>
					</div>
				</div>
				<Footer />
			</div>			
		);
	}
}
function mapStateToProps(state) {
	const { alert } = state;
	const { registering } = state.reg;
	const { whitelabel } = state.whitelabel;
	return {
		alert,
		registering,
		whitelabel,
	};
}


export default withRouter(connect(mapStateToProps)(ConfirmationView));


// export default ConfirmationView;



// WEBPACK FOOTER //
// ./src/components/Confirmation/index.js